import { Routes, Route, Navigate } from 'react-router';
import { ProtectedRoute } from '../components/ProtectedRoute';

// Partner Components
import PartnerDashboard from '../partner/Dashboard';
import SalesFans from '../partner/subscribers/sales-fans';
import CreateOffer from '../partner/subscribers/sales-fans/create-offer';
import Orders from '../partner/subscribers/orders';
import Campaigns from '../partner/statistic/campaigns';
import Wallet from '../partner/account/Wallet';
import Settings from '../partner/account/Settings';

// Revshare Components
import RevshareOffers from '../partner/revshare/offers';
import RevshareAccounts from '../partner/revshare/accounts';
import RevshareCampaigns from '../partner/revshare/campaigns';
import RevshareSubscribers from '../partner/revshare/subscribers';
import RevshareTransactions from '../partner/revshare/transactions';
import RevshareCosts from '../partner/revshare/costs';
import RevshareIncome from '../partner/revshare/income';

const PartnerRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Partner Routes - Require Partner Authentication */}
      <Route path="/" element={<Navigate to="/dashboard" replace />} />

      <Route
        path="/dashboard"
        element={
          <ProtectedRoute requiredRole="partner">
            <PartnerDashboard />
          </ProtectedRoute>
        }
      />

      <Route
        path="/subscribers/sales"
        element={
          <ProtectedRoute requiredRole="partner">
            <SalesFans />
          </ProtectedRoute>
        }
      />

      <Route
        path="/subscribers/orders"
        element={
          <ProtectedRoute requiredRole="partner">
            <Orders />
          </ProtectedRoute>
        }
      />

      <Route
        path="/subscribers/sales/create-offer"
        element={
          <ProtectedRoute requiredRole="partner">
            <CreateOffer />
          </ProtectedRoute>
        }
      />

      <Route
        path="/subscribers/sales/:id/edit"
        element={
          <ProtectedRoute requiredRole="partner">
            <CreateOffer />
          </ProtectedRoute>
        }
      />

      <Route
        path="/statistics/campaigns"
        element={
          <ProtectedRoute requiredRole="partner">
            <Campaigns />
          </ProtectedRoute>
        }
      />

      <Route
        path="/account/wallet"
        element={
          <ProtectedRoute requiredRole="partner">
            <Wallet />
          </ProtectedRoute>
        }
      />

      <Route
        path="/account/settings"
        element={
          <ProtectedRoute requiredRole="partner">
            <Settings />
          </ProtectedRoute>
        }
      />

      {/* Revshare Routes */}
      <Route
        path="/revshare/offers"
        element={
          <ProtectedRoute requiredRole="partner">
            <RevshareOffers />
          </ProtectedRoute>
        }
      />

      <Route
        path="/revshare/accounts"
        element={
          <ProtectedRoute requiredRole="partner">
            <RevshareAccounts />
          </ProtectedRoute>
        }
      />

      <Route
        path="/revshare/campaigns"
        element={
          <ProtectedRoute requiredRole="partner">
            <RevshareCampaigns />
          </ProtectedRoute>
        }
      />

      <Route
        path="/revshare/subscribers"
        element={
          <ProtectedRoute requiredRole="partner">
            <RevshareSubscribers />
          </ProtectedRoute>
        }
      />

      <Route
        path="/revshare/transactions"
        element={
          <ProtectedRoute requiredRole="partner">
            <RevshareTransactions />
          </ProtectedRoute>
        }
      />

      <Route
        path="/revshare/costs"
        element={
          <ProtectedRoute requiredRole="partner">
            <RevshareCosts />
          </ProtectedRoute>
        }
      />

      <Route
        path="/revshare/income"
        element={
          <ProtectedRoute requiredRole="partner">
            <RevshareIncome />
          </ProtectedRoute>
        }
      />

      {/* Add more partner routes here as needed */}
    </Routes>
  );
};

export default PartnerRoutes;
